import omit from "lodash/omit";
import { RestAPIClient } from "networks";
import { HTTPRequestMethods } from "networks/RestAPI/client";
import { getOrgId } from "utils";

import Paths from "./paths";
import * as Types from "./types";

export const companyDetailService = (id: string) =>
  RestAPIClient.call<Types.Company>({
    method: HTTPRequestMethods.GET,
    url: `${Paths.Detail}/${id}`,
    config: {
      requireAuthentication: true,
    },
  });

export const companyUpdateService = (param: Types.CompanyUpdateRequest) =>
  RestAPIClient.call<Types.Company>({
    method: HTTPRequestMethods.PUT,
    url: `${Paths.Detail}/${param.id}`,
    config: {
      requireAuthentication: true,
    },
    data: param,
  });

export const companySettingListService = (
  params: Types.CompanySettingListRequest
) =>
  RestAPIClient.call<Types.CompanySettingListResponse>({
    method: HTTPRequestMethods.GET,
    url: `${Paths.SettingDetail.replace("{orgId}", getOrgId())}`,
    config: {
      requireAuthentication: true,
      params,
    },
  });

export const companySettingUpdateService = (
  params: Types.CompanySettingUpdateRequest
) =>
  RestAPIClient.call<Types.CompanySettingDetail>({
    method: HTTPRequestMethods.PUT,
    url: `${Paths.SettingDetail.replace("{orgId}", getOrgId())}/${params.id}`,
    config: {
      requireAuthentication: true,
    },
    data: omit(params, "id"),
  });
